// Saving a file the API served.
//
// Every route but the sign-in config is behind the API Gateway JWT authorizer,
// which reads the `Authorization` header — and a browser navigation cannot send
// one, so a plain `<a href>` to an API path comes back "Unauthorized". Anything
// downloadable is therefore FETCHED with the token and handed to the browser
// here, as a blob it is asked to save.

export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  // Next tick: a URL revoked in the same task as the click can cancel the
  // download before the browser has read it.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
